<script lang="ts">
  import FicheBanque from '@/generated/fiches/FicheBanque.vue';
  import BankLog, { BankDay } from '@/generated/classes/BankLog';
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {},
    extends: FicheBanque,
    data() {
      const daySelected: BankDay = new BankDay;

      return {
        daySelected
      };
    },
    computed: {
      selectedBankLog(): BankDay {
        return this.daySelected as unknown as BankDay;
      }
    },
    methods: {
      bankLogUpdated(bankDay: BankDay) {
        this.daySelected = bankDay as unknown as BankDay
      }
    }
  })

</script>
